import { useEffect, useState, type ReactNode } from 'react';

export type SortDirection='asc'|'desc';
export interface SortState<K extends string>{key:K;direction:SortDirection;}

export function useTableSort<K extends string>(storageKey:string,initial:SortState<K>){
  const [sort,setSort]=useState<SortState<K>>(()=>{
    try{
      const saved=window.localStorage.getItem(storageKey);
      if(saved){const parsed=JSON.parse(saved) as SortState<K>;if(parsed?.key&&(parsed.direction==='asc'||parsed.direction==='desc'))return parsed;}
    }catch{/* Optional UI preference only. */}
    return initial;
  });
  useEffect(()=>{try{window.localStorage.setItem(storageKey,JSON.stringify(sort));}catch{/* Optional UI preference only. */}},[storageKey,sort]);
  const toggle=(key:K,firstDirection:SortDirection='asc')=>setSort(current=>current.key===key?{key,direction:current.direction==='asc'?'desc':'asc'}:{key,direction:firstDirection});
  return {sort,toggle};
}

export function compareText(a:string|undefined,b:string|undefined,direction:SortDirection){
  return String(a||'').localeCompare(String(b||''),undefined,{sensitivity:'base',numeric:true})*(direction==='asc'?1:-1);
}
export function compareNumber(a:number|undefined|null,b:number|undefined|null,direction:SortDirection){
  const aMissing=a==null||Number.isNaN(a),bMissing=b==null||Number.isNaN(b);
  if(aMissing&&bMissing)return 0;if(aMissing)return 1;if(bMissing)return -1;
  return ((a as number)-(b as number))*(direction==='asc'?1:-1);
}
export function compareDate(a:string|undefined,b:string|undefined,direction:SortDirection){
  const av=a?Date.parse(a):Number.NaN,bv=b?Date.parse(b):Number.NaN;
  return compareNumber(Number.isNaN(av)?undefined:av,Number.isNaN(bv)?undefined:bv,direction);
}

export function SortHeader({label,active,direction,onClick,className='',children}:{label:string;active:boolean;direction:SortDirection;onClick:()=>void;className?:string;children?:ReactNode}){
  return <span className={`sortableHeadCell ${className}`.trim()}>
    <button type="button" className={`sortableHeadButton ${active?'active':''}`.trim()} onClick={onClick} aria-label={`Sort by ${label}${active?`, currently ${direction==='asc'?'ascending':'descending'}`:''}`}>
      <span className="sortableHeadLabel">{children??label}</span><span className="sortableHeadArrow" aria-hidden="true">{active?(direction==='asc'?'↑':'↓'):'↕'}</span>
    </button>
  </span>;
}
